import {atom} from 'recoil';

export const defaultValue = {
    type: 'flightInformationType_1',
    clickAddress: '',
    simulationNumber: 0,
    simulationStep: 1
};

const informationAtom = atom({
    key: 'information',
    default: defaultValue
});

export {informationAtom};
